import React from 'react';

const DebugContext = React.createContext(false);
export { DebugContext };
